import React from 'react';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import MedicalRequestCreate from './MedicalRequestCreate';

interface Props {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	patientId: string;
	onCreate: (jobId?: string) => void;
	autoOpenByKey?: string;
	caseId?: string;
}

const MedicalRequestCreateModal: React.FC<Props> = ({
	isOpen,
	setIsOpen,
	patientId,
	onCreate,
	autoOpenByKey,
	caseId,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={isOpen}
			onClose={() => setIsOpen(false)}
			wrapChat={isCase}
			size={Size.MD}>
			<Modal.Header title='component.medicalRequestForms.modalTitle' />
			<Modal.Content contentScroll>
				<MedicalRequestCreate
					patientId={patientId}
					onSuccess={onCreate}
					autoOpenByKey={autoOpenByKey}
					caseId={caseId}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default MedicalRequestCreateModal;
